import { render, staticRenderFns } from "./MSRadionContainer.vue?vue&type=template&id=07d24923&"
import script from "./MSRadionContainer.vue?vue&type=script&lang=js&"
export * from "./MSRadionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports